"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.textTransform = void 0;

var _constants = require("../constants");

// text transform
var textTransform = _constants.TEXT_TRANSFORMS.reduce(function (result, t) {
  var output = result;
  output[t] = false;
  return output;
}, {});

exports.textTransform = textTransform;